import store from '../redux/store';

export const getUserDetails = () => {
  return store?.getState()?.omniProfile?.profileDetail?.fetchProfileDetails
    ?.data;
};

export const checkPermission = (
  profile,
  module,
  actionType,
  permission = 'E'
) => {
  const userData = getUserDetails();

  const permData = userData?.actionable;

  // Normalize profile key to handle both 'custombroker' and 'customBroker'
  const normalizedProfile = Object.keys(permData || {}).find(
    (key) => key.toLowerCase() === profile.toLowerCase()
  );

  if (!normalizedProfile) return false;

  let actType = {};

  permData?.[normalizedProfile]?.[module]?.forEach((actionModule) => {
    if (actionModule?.actionName === actionType) {
      actType = actionModule;
    }
  });

  return actType?.actions?.includes(permission) || false;
};

export const hasNoOrderPerm = (profile, module = 'Order') => {
  const userData = getUserDetails();
  const permData = userData?.actionable;
  if (!permData || !permData?.[profile] || !permData?.[profile]?.[module]) {
    return false;
  }
  // Check if every action in the module includes 'N'
  return permData?.[profile]?.[module]?.every((actionModule) =>
    actionModule?.actions?.includes('N')
  );
};
